import React from 'react'
import cs from 'classnames'
import { FormattedMessage, injectIntl } from 'react-intl'
import intlMessagesApp from 'src/modules/App/translations'

import SvgIcon from 'src/components/SvgIcon'
import pixel from '../../../assets/Pixel5.png'
import pixelFr from '../../../assets/Pixel5_FR.png'

import commonStyles from '../../common.module.less'

import styles from './styles.module.less'

export default injectIntl(props => {
  const screenshot = props.language === 'fr' ? pixelFr : pixel
  return (
    <section className={cs(commonStyles.container)}>
      <section className={commonStyles.top}>
        <img
          src={screenshot}
          className={styles.bgStep}
          alt={props.intl.formatMessage(intlMessagesApp.altScreenshot)}
        />
      </section>
      <section className={commonStyles.bottom}>
        <div className={commonStyles.content}>
          <header>
            <SvgIcon
              className={commonStyles.iconFabStep}
              size='xlg'
              type='UnlockedIcon'
              style={{ margin: '5px auto' }}
            />
            <h2>
              <FormattedMessage id='app.lock.screen.header.privacy' defaultMessage='Privacy' />
            </h2>
            <p>
              <FormattedMessage
                id='app.lock.screen.header.privacy.description2'
                defaultMessage='Turn off Screen Sharing'
              />
            </p>
          </header>
          <div className={commonStyles.scrollable}>
            <p>
              <FormattedMessage
                id='app.lock.android.screen5.p1'
                defaultMessage='Follow the steps on your device. Unpinning screen may differ depending on your device manufacturer and/or android version.'
              />
            </p>
          </div>
        </div>
      </section>
    </section>
  )
})
